module.exports = __webpack_public_path__ + "img/6_003.a293f86e.webp";